import React from 'react';

export const Hours = () => {
    return (
        <div className="holiday-border">
            <h3>Holiday Hours</h3>
            <p>Memorial Day - 1/2 day</p>
            <p>4th of July - closed</p>
            <p>Labor Day - closed</p>
            <p>Thanksgiving day - closed</p>
            <p>December 25 - closed</p>
            <p>December 26 - 9:00 - 11:30</p>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/hours/hours.jsx